import React, { useState } from "react";
import { useTheme } from "../../contexts/ThemeContext";
import Sidebar from "./Sidebar";
import Header from "./Header";

const DashboardLayout = ({ children, user, userRole, isLoadingUserRole }) => {
  const { themeClasses, effectiveTheme } = useTheme();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div
      className={`min-h-screen transition-colors duration-300 ${
        effectiveTheme === "light" ? "bg-gray-50" : "bg-gray-900"
      }`}
    >
      {/* Header */}
      <Header
        user={user}
        userRole={userRole}
        isLoadingUserRole={isLoadingUserRole}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />

      <div className="flex">
        {/* Sidebar */}
        <Sidebar
          userRole={userRole}
          mobileMenuOpen={mobileMenuOpen}
          setMobileMenuOpen={setMobileMenuOpen}
        />

        {/* Main Content */}
        <div className="flex-1 lg:ml-64">
          <div className="p-4 lg:p-8">
            <div
              className={`transition-colors duration-300 ${themeClasses.text.primary}`}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
